import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  EvaluateSupportConversationRequest,
  UpdateAllCommentStatusRequest,
  UpdateAllPostStatusRequest,
  UpdateCommentStatusRequest,
  UpdatePostStatusRequest,
  ViewApprovalCountRequest,
  ViewApprovalMembersRequest,
  ViewApprovalsForUserRequest,
  ViewApprovalsRequest
} from './approval.types';

export const requestViewApprovalCount =
  createAction<SagaPayload<ViewApprovalCountRequest>['payload']>('request/viewApprovalCount');

export const requestViewApprovalMembers =
  createAction<SagaPayload<ViewApprovalMembersRequest>['payload']>('request/viewApprovalMembers');

export const requestViewApprovals = createAction<SagaPayload<ViewApprovalsRequest>['payload']>('request/viewApprovals');

export const requestUpdatePostStatus =
  createAction<SagaPayload<UpdatePostStatusRequest>['payload']>('request/updatePostStatus');

export const requestUpdateCommentStatus =
  createAction<SagaPayload<UpdateCommentStatusRequest>['payload']>('request/updateCommentStatus');

export const requestUpdateAllPostStatus =
  createAction<SagaPayload<UpdateAllPostStatusRequest>['payload']>('request/updateAllPostStatus');

export const requestUpdateAllCommentStatus = createAction<SagaPayload<UpdateAllCommentStatusRequest>['payload']>(
  'request/updateAllCommentStatus'
);

export const requestViewApprovalsForUser =
  createAction<SagaPayload<ViewApprovalsForUserRequest>['payload']>('request/viewApprovalsForUser');

export const requestEvaluateSupportConversation = createAction<
  SagaPayload<EvaluateSupportConversationRequest>['payload']
>('request/checkForSupportConversation');
